import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

/**
 * The Save as Draft button shown beside Submit on a request form, with a note of which draft is being edited.
 */
@Component({
    selector: 'xp-draft-actions',
    standalone: true,
    imports: [MatButtonModule],
    template: `
        <button mat-stroked-button type="button" class="draft-btn"
                [disabled]="busy() || disabled()"
                (click)="saveDraft.emit()">
            {{ busy() ? 'Saving…' : 'Save as Draft' }}
        </button>
        @if (draftName(); as name) {
        <span class="draft-hint">Editing {{ name }}</span>
        }
    `,
    styles: [`
        :host { display: inline-flex; align-items: center; gap: 12px; }
        .draft-hint { font-size: 13px; opacity: 0.75; }
    `]
})
export class DraftActionsComponent {
    /** The name of the draft being edited, such as "Payment draft 2", if any. */
    readonly draftName = input<string | null>(null);

    /** True while a save is in progress. */
    readonly busy = input(false);

    /** True when saving should not be offered, for example before the user has entered anything. */
    readonly disabled = input(false);

    /** Raised when the user clicks Save as Draft. */
    readonly saveDraft = output<void>();
}
